import Omy from "../Omy";

export default class Browser {
    constructor(os) {
        this._os = os;
        this.chrome = false;
        this.chromeVersion = 0;
        this.edge = false;
        this.firefox = false;
        this.firefoxVersion = 0;
        this.ie = false;
        this.ieVersion = 0;
        this.mobileSafari = false;
        this.opera = false;
        this.safari = false;
        this.safariVersion = 0;
        this.silk = false;
        this.trident = false;
        this.tridentVersion = 0;
        this.init();
        this._isWebpSupported = false;
        this._webpIsSupported(this._checkWeResult.bind(this));
        this._isOggSupported = false;
        let testEl = document.createElement("video");
        if (testEl.canPlayType) {
            let testStr = testEl.canPlayType("audio/ogg");
            this._isOggSupported = Boolean(testStr.length);
        }
    }

    _checkWeResult(isSupported) {
        this._isWebpSupported = isSupported;
        // if (isSupported) {
        //     console.log("Supported");
        // } else {
        //     console.log("Not supported");
        // }
    }

    _webpIsSupported(callback) {
        // If the browser doesn't has the method createImageBitmap, you can't display webp format
        if (!window.createImageBitmap) {
            callback(false);
            return;
        }

        // Base64 representation of a white point image
        let webpdata = "data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoCAAEAAQAcJaQAA3AA/v3AgAA=";

        // Retrieve the Image in Blob Format
        fetch(webpdata).then(function(response) {
            return response.blob();
        }).then(function(blob) {
            // If the createImageBitmap method succeeds, return true, otherwise false
            createImageBitmap(blob).then(function() {
                callback(true);
            }, function() {
                callback(false);
            });
        });
    }

    init() {
        let ua = navigator.userAgent;

        if (/Edge\/\d+/.test(ua)) {
            this.edge = true;
        } else if ((/Chrome\/(\d+)/).test(ua) && !this._os.windowsPhone) {
            this.chrome = true;
            this.chromeVersion = parseInt(RegExp.$1, 10);
        } else if ((/Firefox\D+(\d+)/).test(ua)) {
            this.firefox = true;
            this.firefoxVersion = parseInt(RegExp.$1, 10);
        } else if ((/AppleWebKit/).test(ua) && this._os.iOS) {
            this.mobileSafari = true;
        } else if ((/MSIE (\d+\.\d+);/).test(ua)) {
            this.ie = true;
            this.ieVersion = parseInt(RegExp.$1, 10);
        } else if ((/Opera/).test(ua)) {
            this.opera = true;
        } else if ((/Safari/).test(ua) && !this._os.windowsPhone) {
            this.safari = true;
        } else if ((/Trident\/(\d+\.\d+)(.*)rv:(\d+\.\d+)/).test(ua)) {
            this.ie = true;
            this.trident = true;
            this.tridentVersion = parseInt(RegExp.$1, 10);
            this.ieVersion = parseInt(RegExp.$3, 10);
        }

        //  Silk gets its own if clause because its ua also contains 'Safari'
        if ((/Silk/).test(ua)) {
            this.silk = true;
        }
        return this;
    }

    get isWebpSupported() {
        return this._isWebpSupported && !Omy.offWebpSupport;
    }

    get isOggSupported() {
        return this._isOggSupported;
    }
}
